import { OrderComment } from './order-comment';

export interface OrderCommentsResponse {
  count: number;
  comments: OrderComment[];
}
